<script>
import {dictMixin, formMixin} from "@/mixins";
import {expert_file} from "@/api/projectReviewService";
import dataCheck from "@/utils/dataCheck";


export default {
    name: "AddTitleFile",
    components: {},
    mixins:[formMixin, dictMixin],
    data(){
        return{
            submitUrl: expert_file.save,
            form:{},
            rules: {
                expertId:[],
                fileCategory:[],
                fileName:[dataCheck.required({})],
                fileLevel:[],
                filePath:[dataCheck.required({})]
            }
        }
    },
    methods:{

    }
}
</script>

<template>
    <a-modal width="50%" title="新增职称/职(执)资格证书" :visible="visible" centered :destroy-on-close="true"
             :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose">
        <a-form ref="ruleForm" :model="form" :rules="rules" @submit="onSubmit">
            <a-row :gutter="20">
                <a-col :span="24">
                    <a-form-item label="职称/职(执)资格证书名称" name="fileName">
                        <a-input v-model:value="form.fileName" placeholder="请输入"/>
                    </a-form-item>
                </a-col>
<!--                <a-col :span="24">-->
<!--                    <a-form-item label="职称/职(执)资格等级" name="fileLevel">-->
<!--                        <DictRadio v-model:value="form.fileLevel" :dict-name="'title_level'"/>-->
<!--                    </a-form-item>-->
<!--                </a-col>-->
                <a-col :span="24">
                    <a-form-item label="职称/职(执)资格证书(PDF)" name="filePath">
                        <FileUpload names="职称证书" v-model:value="form.filePath" :is-pdf="true" :multiple="false" :size="50" :count="1"></FileUpload>
                    </a-form-item>
                </a-col>
            </a-row>
        </a-form>
    </a-modal>
</template>

<style scoped lang="less">
:deep(.ant-upload-list-item){
    margin-top: 0;
}
:deep(.ant-upload  .ant-btn){
    background-color: #0059b5 !important;
    color: #fff !important;
}
</style>
